import { IconTable } from '@components/table/IconTable';
import { CardContainer } from 'layout/Card';
import { useTheme } from 'context/ThemeProvider/ThemeProvider';
import { type FC, useState } from 'react';
import useGetQuickWinTableColumns from './useGetQuickWinTableColumns';
import { useNavigate } from 'react-router-dom';
import { type EnergyAudit } from 'interfaces/EnergyAudit.interface';

const QuickWinTable: FC<{ data?: EnergyAudit[]; isFetching: boolean }> = ({
  data,
  isFetching,
}) => {
  const [hoveredId, setHoveredId] = useState<number | undefined>();
  const { theme } = useTheme();
  const { columns } = useGetQuickWinTableColumns();
  const navigate = useNavigate();

  const handleRowClick = (opportunity: EnergyAudit): void => {
    if (opportunity?.id) {
      navigate(
        `/app/management/energy_audit/${opportunity.connection_point_id_client}`
      );
    }
  };

  return (
    <CardContainer className="p-4 bg-white shadow-md rounded-lg flex flex-col w-full">
      <IconTable
        minHeight={300}
        maxHeight={300}
        skeletonAmountWhenLoading={5}
        isFetching={isFetching}
        enableRowBorder={false}
        stripped={false}
        hoverColor={theme.colors['primary-lighter']}
        hoveredId={hoveredId}
        onRowHover={setHoveredId}
        enableRowRoundedBorder={true}
        data={data ?? []}
        onClickRow={handleRowClick}
        columns={columns}
        emptyTableMessage="No quick wins detected"
      />
    </CardContainer>
  );
};

export default QuickWinTable;
